<template class="w-100">
  <div class="content w-100">
      <div class="title bg-success"> 
          <button class="btn btn-outline-light btn-plus-ticket" @click="ticketModalOpened = true"><Icon icon="mdi:plus"></Icon></button>
           <ModalContent class="text-dark" title="Criar ticket" :is-modal-open="this.ticketModalOpened"
            @close="() => this.ticketModalOpened = false" 
              @send="() => {
                createTicket();
                this.ticketModalOpened = false
            }">
            
            <select v-model="newTicket.companyId" class="form-select mt-2">
              <option value="" disabled selected>Selecione uma empresa</option>
              <option v-for="client in showingClients" :key="client.id" :value="client.id">{{ client.name }}</option>
            </select>
            <textarea v-model="newTicket.title" class="form-control" rows="5" placeholder="Escreva o título..."></textarea>
          </ModalContent>
          Tickets
          
          <div class="sla-info">
            <div
              class="text-white"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="'#tickets'"
              aria-expanded="false"
            >
            <div class="d-flex counter gap-1 justify-content-center" :class="slaColor">
              {{ slaInicial + fallowup }}  <div v-if="slaInicial + fallowup > 0 "><Icon  icon="mdi:notebook-outline" class="icon"/></div>
            </div>
          </div>
      </div>
  </div>
  </div>
  <div id="tickets" class="collapse"  v-if="showTickets">
    <div v-if="(ticketsUncommented.length || ticketsFallowupExpired.length)" class="mb-3">
      <div class="table-responsive">
        <table class="table table-sm align-middle">
          <thead>
            <tr >
              <th class="type">Tipo</th>
              <th>Empresa</th>
              <th>ID</th>
              <th>Assunto</th>
              <th>Expirado</th>
              <th class="action"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="waitingTicket in allWaitingTickets"
                :key="waitingTicket.id + '-' + waitingTicket.statusType"
                :class="waitingTicket.colorClass">
              <td class="type">{{ waitingTicket.statusType === 'fallowup' ? 'Follow-up' : 'Inicial' }}</td>
              <td class="uppercase">{{  waitingTicket.company.name }}</td>
              <td>{{ waitingTicket.ticketId }}</td>
              <td>{{ waitingTicket.ticketTitle }}</td>
              <td>{{ waitingTicket.tempoVencidoMin }} min</td>
              <td class="action">
                <button @click="openProblemModal(waitingTicket.id)" class="btn btn-danger btn-sm" type="button">Let´s rock</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ModalContent 
    width="1200px"
    :is-modal-open="isProblemModalOpen" 
    @close="closeProblemModal" 
    hideSend="true"
    :show-footer="false">
    <ProblemView v-if="selectedProblemId" :problem-id="selectedProblemId" />
  </ModalContent>
</template>

<script>
import { updateTime } from '@/configs/general';
import { getColorClass } from '@/services/utils';
import { problemService, TicketMetroService } from '@/services/backend/ApiService';
import { ProblemStatus } from '../../../../zabbix-shared/interfaces/intefaces';
import { metroCompanyId } from '../../../../zabbix-shared/env';
import { Icon } from '@iconify/vue';
import ModalContent from '@/components/ModalContent.vue';
import ProblemView from '@/pages/resolution/ProblemView.vue';

export default {
    components: {
        Icon,
        ModalContent,
        ProblemView
    },
    props: {
        showingClients: {
            type: Array,
            default: () => ([])
        }
    },
  data() {
    return {
      newTicket: {
        title: '',
        companyId: '',
      },
      ticketModalOpened: false,
      ticketsCse: [],
      ticketsNoc: [],
      ticketsUncommented: [],
      ticketsFallowupExpired: [],
      intervalId: null,
      colorClass: '',
      isFetching: false,
      slaInicial: 0,
      slaColor: '',
      fallowup: 0,
      isProblemModalOpen: false,
      selectedProblemId: null,
      iconsColors: [
        {
            colorClass: "bg-secondary",
            quantity: -5
        },
        {
            colorClass: "bg-fine",
            quantity: 0,
        },
        {
            colorClass: "bg-warning",
            quantity: 15
        },
        {
            colorClass: "bg-danger",
            quantity: 30
        }
      ],
      ticketsColors: [
        {
            colorClass: "bg-secondary",
            quantity: -5
        },
        {
            colorClass: "bg-fine",
            quantity: 0,
        },
        {
            colorClass: "bg-warning",
            quantity: 15
        },
        {
            colorClass: "bg-danger",
            quantity: 30
        }
    ]
    };
  },
    async mounted() {
        this.startFetchingwaitingTickets();
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
    },
    methods: {
    async fetchwaitingTickets() {
            if (this.isFetching) return;
            this.isFetching = true;
            try {
              const problems = await problemService.findAll({
                 status: ProblemStatus.ACKNOWLEDGE,
                  createdAt: {
                      $gte: new Date('2025-08-12T00:00:00.000Z')
                  },
                  select: {
                      id: true,
                      ticketId: true,
                      ticketTitle: true,
                      fallowupTime: true,
                      createdAt: true,
                      company: {
                          id: true,
                          name: true
                      }
                  }
              });

              let filteredProblems = problems.filter(value => this.showingClients.some(client => client.id === value.company.id));
            
              this.ticketsFallowupExpired = filteredProblems.filter((problem) => {
                  return problem.fallowupTime != null && (Date.now() > new Date(problem.fallowupTime).getTime());
              });

              const tenMinutes = 10 * 60 * 1000; 
              const now = Date.now();

              this.ticketsUncommented = filteredProblems.filter((problem) => {
                  const createdAt = new Date(problem.createdAt).getTime();
                  return problem.fallowupTime == null && (now + tenMinutes) > createdAt;
              });

            } catch (error) {
                console.error("Erro ao buscar clientes:", error);
            } finally {
                this.isFetching = false;
                this.emitTicketCounts();
            }
        },
        emitTicketCounts() {
            this.slaInicial = Array.isArray(this.ticketsUncommented) ? this.ticketsUncommented.length : 0;
            this.fallowup = Array.isArray(this.ticketsFallowupExpired) ? this.ticketsFallowupExpired.length : 0;

            this.slaColor = getColorClass(this.slaInicial + this.fallowup, this.iconsColors);

            this.$emit('update:slaInicial', this.slaInicial);
            this.$emit('update:fallowup', this.fallowup);
        },
        startFetchingwaitingTickets() {
            this.fetchwaitingTickets();
            this.intervalId = setInterval(() => {
                this.fetchwaitingTickets();
            }, updateTime);
        },
        openProblemModal(problemId) {
            this.selectedProblemId = problemId;
            this.isProblemModalOpen = true;
        },
        closeProblemModal() {
            this.isProblemModalOpen = false;
            this.selectedProblemId = null;
            this.fetchwaitingTickets();   
        },
        async createTicket() {
          const company = this.showingClients.find(c => c.id === this.newTicket.companyId);
          const body = {
            zabbixId: company.zabbixs[0].id,
            description: "",
            company: {id: company.id},
            ticketType: 49,
            subject: this.newTicket.title,
            title: this.newTicket.title,
          }

          const ticketResponse = await TicketMetroService.open(body);

          let problem = {
              company: {
                  id: company.id
              },
              ticketTitle: this.newTicket.title,
              zabbix: { id: company.zabbixs[0].id },
              status: ProblemStatus.ACKNOWLEDGE,
              ticketId: ticketResponse.data.id,
          };

          await problemService.create(problem);
        },
    },
  computed: {
    showTickets() {
      return  true
    },
    isMetro() {
      return this.clientId == metroCompanyId;
    },
    allWaitingTickets() {
      const now = Date.now();
      const fallowup = (this.ticketsFallowupExpired || []).map(t => {
        const vencimento = t.fallowupTime ? new Date(t.fallowupTime).getTime() : 0;
        const tempoVencidoMin = vencimento && now > vencimento ? Math.floor((now - vencimento) / 60000) : 0;
        return {
          ...t,
          statusType: 'fallowup',
          colorClass: getColorClass(tempoVencidoMin, this.ticketsColors),
          tempoVencidoMin
        };
      });
      const inicial = (this.ticketsUncommented || []).map(t => {
        const vencimento = t.createdAt ? new Date(t.createdAt).getTime() : 0;
        const tempoVencidoMin = vencimento && now > vencimento ? Math.floor((now - vencimento) / 60000) : 0;
        return {
          ...t,
          statusType: 'inicial',
          colorClass: getColorClass(tempoVencidoMin, this.ticketsColors),
          tempoVencidoMin
        };
      });

      return [...fallowup, ...inicial].sort((a, b) => {
        return b.tempoVencidoMin - a.tempoVencidoMin;
      });
    }
  },
}
</script>

<style scoped>
.btn-plus-ticket{
  position: absolute;
  top: 3px;
  left: 20px;
  z-index: 1;
}

.type {
  width: 150px !important;
}
.action {
  width: 100px;
}

.sla-info{
  position:absolute;
  font-size: 18px;
  top: 7px;
  right: 20px;
}

td{
  background-color: transparent !important; 
}

.bg-problem {
  background-color: #d7f8f3 !important;
}

.bg-fine {
  background-color: #adffb4 !important;
}

.bg-warning {
  background-color: #fff2c2 !important;
}

.bg-danger {
  background-color: #ffcfd4 !important;
}

.counter{
  border-radius: 30px;
  width: 60px;
  white-space: 80px;
}

.counter.bg-problem {
  background-color: #c74141 !important;
}

.counter.bg-fine {
  background-color: #44ff8d !important;
}

.counter.bg-warning {
  background-color: #ffaf23 !important;
}

.counter.bg-danger {
  background-color: #ff4848 !important;
}
</style>